/* pl-reveal.js — shared reveal-on-scroll + count-up for the pl-* section library.
   Self-initializing, idempotent, no dependencies. */
(function () {
  'use strict';
  if (window.__plRevealInit) return;
  window.__plRevealInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Count numbers up over 1.2s with ease-out cubic. Target comes from the
     [data-countup] attribute or, when empty, the element text ("4,8" works). */
  function countUp(el) {
    if (el.__plCounted) return;
    el.__plCounted = true;
    var raw = String(el.getAttribute('data-countup') || el.textContent || '0').trim();
    var target = parseFloat(raw.replace(',', '.')) || 0;
    var dec = (raw.split(/[.,]/)[1] || '').length;
    var sep = raw.indexOf(',') > -1 ? ',' : '.';
    var suffix = el.getAttribute('data-countup-suffix') || '';
    function fmt(v) { return v.toFixed(dec).replace('.', sep) + suffix; }
    if (reduced) { el.textContent = fmt(target); return; }
    var start = null;
    var DURATION = 1200;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / DURATION, 1);
      el.textContent = fmt(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function reveal(el) {
    el.classList.add('pl-in');
    var children = el.querySelectorAll('[data-reveal-child]');
    for (var i = 0; i < children.length; i++) {
      children[i].style.transitionDelay = reduced ? '0ms' : (i * 80) + 'ms';
      children[i].classList.add('pl-in');
    }
    el.querySelectorAll('[data-countup]').forEach(countUp);
  }

  function init() {
    var els = document.querySelectorAll('[data-reveal]:not(.pl-observed)');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pl-observed'); reveal(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { reveal(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { el.classList.add('pl-observed'); io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Re-scan when sections are (re)loaded in the theme editor. */
  document.addEventListener('shopify:section:load', init);
})();

/* pl-fx — premium effect toolkit layered on the reveal system. Zero deps.
   Attributes: data-fx-parallax (speed, max 60px) · data-fx-words (staggered
   word rise) · data-fx-tilt (3D card tilt) · data-fx-magnetic (cursor pull)
   · data-fx-counter (count-up incl. decimals, alias of data-countup)
   · data-fx-progress (scroll progress bar) · data-fx-zoom (Ken-Burns).
   Hard-disabled under prefers-reduced-motion; degrades to static content. */
(function () {
  'use strict';
  if (window.__plFxInit) return;
  window.__plFxInit = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePtr = window.matchMedia('(pointer: fine)').matches;

  /* Count-up supporting decimals ("4,8") and a data-fx-suffix. */
  function countFx(el) {
    if (el.__plFxCounted) return;
    el.__plFxCounted = true;
    var raw = String(el.getAttribute('data-fx-counter') || el.textContent || '0').trim();
    var target = parseFloat(raw.replace(',', '.')) || 0;
    var dec = (raw.split(/[.,]/)[1] || '').length;
    var sep = raw.indexOf(',') > -1 ? ',' : '.';
    var suffix = el.getAttribute('data-fx-suffix') || '';
    function fmt(v) { return v.toFixed(dec).replace('.', sep) + suffix; }
    if (reduced) { el.textContent = fmt(target); return; }
    var start = null, DUR = 1400;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / DUR, 1);
      el.textContent = fmt(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* Wrap each word in a span; CSS staggers the rise via transition-delay. */
  function splitWords(el) {
    if (el.__plSplit) return;
    el.__plSplit = true;
    var words = (el.textContent || '').trim().split(/\s+/);
    el.textContent = '';
    for (var i = 0; i < words.length; i++) {
      var s = document.createElement('span');
      s.className = 'pl-fx-word';
      s.textContent = words[i];
      s.style.transitionDelay = (i * 80) + 'ms';
      el.appendChild(s);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    }
  }

  /* One shared rAF scroll loop drives all parallax + progress elements. */
  var pxEls = [], progEls = [], ticking = false, loopBound = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight || 1;
    for (var i = 0; i < pxEls.length; i++) {
      var el = pxEls[i], r = el.getBoundingClientRect();
      if (r.bottom < -80 || r.top > vh + 80) continue;
      var sp = parseFloat(el.getAttribute('data-fx-parallax')) || 0.2;
      var y = Math.max(-60, Math.min(60, (r.top + r.height / 2 - vh / 2) * -sp));
      el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
    }
    var max = document.documentElement.scrollHeight - vh;
    var p = max > 0 ? Math.min(1, Math.max(0, (window.scrollY || 0) / max)) : 0;
    for (var j = 0; j < progEls.length; j++) {
      progEls[j].style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  function bindLoop() {
    if (loopBound || (!pxEls.length && !progEls.length)) return;
    loopBound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  /* Pointer 3D tilt, max 6deg, springs back on leave. Desktop only. */
  function tilt(el) {
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var rx = Math.max(-6, Math.min(6, ((e.clientY - r.top) / r.height - 0.5) * -12));
      var ry = Math.max(-6, Math.min(6, ((e.clientX - r.left) / r.width - 0.5) * 12));
      el.style.transition = 'transform .1s ease-out';
      el.style.transform = 'perspective(800px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
    });
    el.addEventListener('pointerleave', function () {
      el.style.transition = 'transform .5s cubic-bezier(.22, 1, .36, 1)';
      el.style.transform = 'perspective(800px)';
    });
  }

  /* Magnetic pull, max 8px, springs back with overshoot. Desktop only. */
  function magnetic(el) {
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var dx = (e.clientX - r.left - r.width / 2) / (r.width / 2);
      var dy = (e.clientY - r.top - r.height / 2) / (r.height / 2);
      el.style.transition = 'transform .15s ease-out';
      el.style.transform = 'translate(' + (dx * 8).toFixed(1) + 'px,' + (dy * 8).toFixed(1) + 'px)';
    });
    el.addEventListener('pointerleave', function () {
      el.style.transition = 'transform .45s cubic-bezier(.34, 1.56, .64, 1)';
      el.style.transform = 'translate(0, 0)';
    });
  }

  function mark(sel, fn) {
    document.querySelectorAll(sel + ':not([data-fx-bound])').forEach(function (el) {
      el.setAttribute('data-fx-bound', '');
      fn(el);
    });
  }

  function initFx() {
    if (!reduced && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target;
          if (el.hasAttribute('data-fx-words')) el.classList.add('pl-fx-words-in');
          if (el.hasAttribute('data-fx-counter')) countFx(el);
          if (el.hasAttribute('data-fx-zoom')) el.classList.add('pl-fx-zoom-on');
          io.unobserve(el);
        });
      }, { threshold: 0.25 });
      mark('[data-fx-words]', function (el) { splitWords(el); io.observe(el); });
      mark('[data-fx-counter]', function (el) { io.observe(el); });
      mark('[data-fx-zoom]', function (el) { io.observe(el); });
      mark('[data-fx-parallax]', function (el) { pxEls.push(el); });
      mark('[data-fx-progress]', function (el) { progEls.push(el); });
      bindLoop();
      if (finePtr) {
        mark('[data-fx-tilt]', tilt);
        mark('[data-fx-magnetic]', magnetic);
      }
    } else {
      /* Reduced motion or no IO: final values, no movement. */
      mark('[data-fx-counter]', countFx);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFx);
  } else {
    initFx();
  }
  document.addEventListener('shopify:section:load', initFx);
})();
